export const blue = {
  100: 'var(--bfc-v2-color-blue-100, #e9f2fe)',
  200: 'var(--bfc-v2-color-blue-200, #cfe1fd)',
  300: 'var(--bfc-v2-color-blue-300, #8fb8f6)',
  400: 'var(--bfc-v2-color-blue-400, #669df1)',
  500: 'var(--bfc-v2-color-blue-500, #4688ec)',
  600: 'var(--bfc-v2-color-blue-600, #357de8)',
  700: 'var(--bfc-v2-color-blue-700, #1868db)',
  800: 'var(--bfc-v2-color-blue-800, #1558bc)',
  900: 'var(--bfc-v2-color-blue-900, #123263)',
  1000: 'var(--bfc-v2-color-blue-1000, #1c2b42)',
  DEFAULT: 'var(--bfc-v2-color-blue-700, #1868db)', // 700
};
